import { createStyles } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  noteTypeParent: {
    backgroundColor: "#ffffff",
    borderRadius: "6px",
    padding:"10px 10px 15px 10px",
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px`,
  },
  labelStyle:{
    marginBottom:"8px"
  }
}));

export default useStyles;
